import { NgModule, Component, OnInit, enableProdMode } from '@angular/core';
import { DynamicFormComponent } from '../dynamic-form/dynamic-form.component';
import { Router } from '@angular/router';
import { FormItemControlService } from '../../services/form-item-control.service';

if (!/localhost/.test(document.location.host)) {
  enableProdMode();
}

@Component({
  selector: 'app-worksheet',
  templateUrl: './worksheet.component.html',
  styleUrls: ['./worksheet.component.scss'],
})

export class WorksheetComponent implements OnInit {
  formCtrlService: FormItemControlService;

  constructor(private router: Router, fcs: FormItemControlService ) {
    this.formCtrlService = fcs;
  }

  ngOnInit() {
    const url = this.router.url;

    // url should look like /liver/2019, so items 1 and 2 of the strs array will contain the organ and year
    const strs = url.split('/');
    if (strs.length === 3) {
      const organ = strs[1];
      const year = strs[2];
      this.formCtrlService.setWorksheetParams(organ, year);
    }
  }


}



